import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AppContainer from "./AppContainer";
import config from "devextreme/core/config";
import { licenseKey } from "./devextreme-license";
import { initializeGlobalGridLayoutPersistence } from "./common/GridLayoutPersistence";

config({ licenseKey });
initializeGlobalGridLayoutPersistence();

const wrapper = document.getElementById("root");

if (wrapper) {
    const root = createRoot(wrapper);
    root.render(
        <BrowserRouter>
            <AppContainer />
        </BrowserRouter>
    );
}